import { useMutation, useQueryClient } from "@tanstack/react-query"
import { makeUpdateKnowledgeBase } from "@/pages/knowledge-bases/domain/use-cases/update-knowledge-base"
import { httpKnowledgeBaseRepository } from "@/pages/knowledge-bases/data/repositories/knowledge-base-repository"
import type { CreateKnowledgeBaseInput } from "@/pages/knowledge-bases/domain/entities/knowledge-base"

const updateKnowledgeBase = makeUpdateKnowledgeBase(httpKnowledgeBaseRepository)

export const useUpdateKnowledgeBase = (id: string) => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: CreateKnowledgeBaseInput) => updateKnowledgeBase(id, input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["knowledge-base", id] })
      void qc.invalidateQueries({
        queryKey: ["knowledge-bases"],
        refetchType: "all",
      })
    },
  })
}
